import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@codex-brightworld/icons';

const LinkWrapper = styled.div`
  text-align: center;
  margin-top: 20px;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.colors.primary.purple};
`;

const VideoIcon = styled(Icon)`
    stroke: none;
    svg path:last-child {
          fill: ${({ theme }) => theme.colors.primary.purple};
    }
`;

const Link = styled.span`
  cursor: pointer;

  :hover {
    text-decoration: underline;
  }
`;

const LinkLabel = styled.span`
  color: ${({ theme }) => theme.colors.primary.purple};
  font-family: ${({ theme }) => theme.fonts.default.fontFamily};
  font-weight: bold;
  padding-right: 5px;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
`;

const VideoLink = ({ videoLinkLabel }) => (
  <LinkWrapper>
    <Link
      role={'link'}
      aria-label={'Link to product video'}
      onClick={(e) => {
        e.preventDefault();

        const productInformationTabEl = document.querySelector('#tab1 > a');
        const productInformationTabContentEl =
          document.querySelector('#tab1 > .tab-content > div');
        const videoEl = document.querySelector('#video');

        // if product information tab is closed we need to open it
        if (productInformationTabEl &&
          productInformationTabContentEl &&
          !productInformationTabEl.classList.contains('tab-active') &&
          !productInformationTabContentEl.classList.contains('tab-expanded')) {
          document.querySelectorAll('.tab-toggle').forEach(
            (tab) => tab.classList.remove('tab-active')
          );
          document.querySelectorAll('.tab-content > div').forEach(
            (tabContent) => tabContent.classList.remove('tab-expanded')
          );

          productInformationTabEl.classList.add('tab-active');
          productInformationTabContentEl.classList.add('tab-expanded');
        }

        // scrolling to video element
        if (videoEl) {
          // IE11 doesn't support window.scrollY so we need to use window.pageYOffset for IE11
          const currentWindowScrollPosition = typeof window.scrollY !== 'undefined'
            ? window.scrollY
            : window.pageYOffset;
          const videoElementVerticalPosition =
            document.querySelector('#video').getBoundingClientRect().top;
          const headerElementWidth = document.querySelector('#header').offsetHeight;

          window.scrollTo({
            behavior: 'smooth',
            // the header height has to be subtracted for mobile/tablet devices
            top: (currentWindowScrollPosition + videoElementVerticalPosition) - headerElementWidth
          });
        }

        // start to play video
        // TODO: starting to play video not working now, check why it's not working
        if (typeof window.DCG !== 'undefined' &&
          typeof window.DCG.isitePlayerAPI !== 'undefined') {
          window.DCG.isitePlayerAPI.play('#isitetv');
        }
      }}
    >
      <LinkLabel>{videoLinkLabel}</LinkLabel>
      <VideoIcon icon={'video_3'} />
    </Link>
  </LinkWrapper>
);

VideoLink.propTypes = {
  videoLinkLabel: PropTypes.string.isRequired
};

export default VideoLink;
